import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { BrickCategory } from '../../../../samwebDescription/samweb/brickCategoryType';
import { BasicBrickComponent } from '../../basic-brick-component';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-brick-not-found-brick',
   templateUrl: './brick-not-found-brick.component.html',
   styleUrls: ['./brick-not-found-brick.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
@SamwebBrick({
   brickDefinitionId: BrickNotFoundBrickComponent.BrickId,
   brickTitleTranslationKey: 'brick.brick-management.brick-not-found',
   brickDescriptionTranslationKey: null,
   brickIcon: WellKnownIconsEnum.ERROR.icon,
   minColWidth: 10,
   minRowHeight: 10,
   brickCategory: BrickCategory.DEBUG,
   disableAddingByUser: true,
   disallowBrickSettings: true,
})
export class BrickNotFoundBrickComponent extends BasicBrickComponent {
   public static BrickId = 'brickNotFound';
   public readonly icon = WellKnownIconsEnum.ERROR.icon;

   constructor() {
      super();
   }
}
